export const workQueueOverdueSectionSelectors = {
  requestAllButton: 'request-all-overdue-reports-button',
  requestAllPopup: 'request-all-overdue-reports-popup'
};
